import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const RecommendationsWordpress = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
   
    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("WordPress Specific", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Includes WordPress-specific security policies you can apply.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">

                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable WordPress Core Auto Updates", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_wp_core_auto_updates"
                                    checked={settingData?.security?.recommendations?.disable_wp_core_auto_updates} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Plugin Auto Updates", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_plugin_auto_updates"
                                    checked={settingData?.security?.recommendations?.disable_plugin_auto_updates} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable Theme Auto Updates", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_theme_auto_updates"
                                    checked={settingData?.security?.recommendations?.disable_theme_auto_updates} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Remove RSD Link", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.remove_rsd_link"
                                    checked={settingData?.security?.recommendations?.remove_rsd_link} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Hide WordPress Version", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.hide_wordpress_version"
                                    checked={settingData?.security?.recommendations?.hide_wordpress_version} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Remove WLW Manifest Link", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.remove_wlw_manifest_link"
                                    checked={settingData?.security?.recommendations?.remove_wlw_manifest_link} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Remove Shortlink", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.remove_shortlink"
                                    checked={settingData?.security?.recommendations?.remove_shortlink} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Shortcode in WP Widgets", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.enable_shortcode_in_wp_widgets"
                                    checked={settingData?.security?.recommendations?.enable_shortcode_in_wp_widgets} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            
        </>
    )
}
export default withForm(RecommendationsWordpress, 'security.recommendations');